export default "__VITE_ASSET__T1i_6v5n__"